import Modal from './Modal';
import ModalCloseButton from './ModalCloseButton';

Modal.CloseButton = ModalCloseButton;

export { Modal, ModalCloseButton };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Modal/index.js
// module id = 712
// module chunks = 0